<template>
  <section class="section partners-section">
    <div class="section-inner">
      <div class="section-header">
        <h2 class="section-title">合作伙伴</h2>
        <p class="section-subtitle">与不同行业头部企业深度合作，共建开放共赢生态。</p>
      </div>
      <div class="partners-grid">
        <button
          v-for="item in partners"
          :key="item.id"
          type="button"
          class="partner-card"
          @click="openLink(item.link)"
        >
          <div class="partner-logo-wrapper">
            <img :src="item.logo" :alt="item.name">
          </div>
          <div class="partner-name">{{ item.name }}</div>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnerLogos',
  computed: {
    partners() {
      return this.$store.getters.getPartnersList
    }
  },
  methods: {
    openLink(link) {
      if (!link) return
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.partners-section {
  background: radial-gradient(circle at top, #0b1220, #020617 58%);
  color: #e5e9f0;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 18px;
}

.partner-card {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 14px 10px;
  border-radius: 14px;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.partner-logo-wrapper {
  height: 64px;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.7);
}

.partner-logo-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.partner-name {
  margin-top: 8px;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
}

.partner-card:hover {
  background: rgba(15, 23, 42, 0.9);
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.9);
}

.partner-card:hover .partner-logo-wrapper {
  transform: translateY(-2px);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.9);
}

@media (max-width: 1024px) {
  .partners-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .partners-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>

